module.exports = __webpack_public_path__ + "static/media/masoleanjam.b3085186.webp";